module.exports = __webpack_public_path__ + "static/media/pl-soft-skills.a0883407.png";